var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { useOneAccount, useShowOneLoginDialog, } from "../../AccountProvider";
import IconGryphline from "../Channels/Official/Gryphline/Icon";
import IconHypergryph from "../Channels/Official/Hypergryph/Icon";
import { RoleContext } from "../context";
import { clearRoleMeta, setRoleMeta } from "../utils";
export var LoginChannelSelectRenderer = function (_a) {
    var onClose = _a.onClose, render = _a.render;
    var _b = useContext(RoleContext), sdkReady = _b.sdkReady, gameCode = _b.gameCode, site = _b.site, onSelectRole = _b.onSelectRole, disableAccount = _b.disableAccount, fetchRoleInfo = _b.fetchRoleInfo, channelConfigList = _b.channelConfigList, fetchAccountRole = _b.fetchAccountRole, onNoRole = _b.onNoRole, onError = _b.onError, dispatch = _b.dispatch;
    var account = useOneAccount().account;
    var showLoginDialog = useShowOneLoginDialog();
    var _c = __read(useState([]), 2), displayChannels = _c[0], setDisplayChannels = _c[1];
    var initial = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var channelRenderList, onSelect, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    channelRenderList = [];
                    if (!!disableAccount) return [3 /*break*/, 2];
                    onSelect = function () {
                        showLoginDialog();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                    };
                    _b = (_a = channelRenderList).push;
                    _c = {
                        channel: "account"
                    };
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    _b.apply(_a, [(_c.displayName = (_d.sent()).Account.meta.subjectName,
                            _c.renderIcon = function (props) {
                                return sdkReady.SDK_TYPE === "HG" ? (_jsx(IconHypergryph, __assign({}, props))) : (_jsx(IconGryphline, __assign({}, props)));
                            },
                            _c.onSelect = onSelect,
                            _c.onLogin = onSelect,
                            _c)]);
                    _d.label = 2;
                case 2:
                    if (channelConfigList.length > 0) {
                        channelConfigList.forEach(function (cfg) {
                            var channel = cfg.channel, displayName = cfg.displayName, handler = cfg.handler, renderIcon = cfg.renderIcon;
                            var onSelect = function () {
                                onClose === null || onClose === void 0 ? void 0 : onClose();
                                handler({
                                    sdkReady: sdkReady,
                                    gameCode: gameCode,
                                    state: { _from: channel, _type: "auth" },
                                    option: cfg.option,
                                });
                            };
                            channelRenderList.push({
                                channel: channel,
                                displayName: displayName,
                                renderIcon: renderIcon,
                                onSelect: onSelect,
                                onLogin: onSelect,
                            });
                        });
                    }
                    setDisplayChannels(channelRenderList);
                    return [2 /*return*/];
            }
        });
    }); }, [disableAccount, sdkReady, gameCode, channelConfigList]);
    var currentAccount = useMemo(function () {
        if (disableAccount || !account)
            return null;
        var onLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sdk, verifier, res, token, roleInfo, roleMeta, shouldGetRoleInClient, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 9, , 10]);
                        return [4 /*yield*/, sdk.Account.API.getToken()];
                    case 3:
                        verifier = (_b.sent()) || "";
                        return [4 /*yield*/, fetchAccountRole()];
                    case 4:
                        res = _b.sent();
                        token = res.token;
                        roleInfo = res.roleInfo;
                        if (!token) {
                            clearRoleMeta({ site: site });
                            onNoRole === null || onNoRole === void 0 ? void 0 : onNoRole({ auto: false });
                            return [2 /*return*/];
                        }
                        roleMeta = {
                            channel: "account",
                            verifier: verifier,
                            token: token,
                        };
                        shouldGetRoleInClient = !fetchRoleInfo;
                        if (!onSelectRole) return [3 /*break*/, 6];
                        return [4 /*yield*/, onSelectRole(roleMeta.token)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (!!shouldGetRoleInClient) return [3 /*break*/, 8];
                        // 先设置 roleMeta 到 store 中
                        // 原因：fetchRoleInfo 的实现可能使用 createRequest 出来的httpClient
                        setRoleMeta(roleMeta, { site: site });
                        return [4 /*yield*/, fetchRoleInfo(roleMeta.token)
                            // 如果不能正常返回，表示角色会话不一致
                        ];
                    case 7:
                        // 携带当前的客户端token与服务器端会话校验
                        // 如果能正常返回用户信息，则表示会话一致
                        roleInfo = _b.sent();
                        // 如果不能正常返回，表示角色会话不一致
                        if (!roleInfo) {
                            clearRoleMeta({ site: site });
                            return [2 /*return*/];
                        }
                        _b.label = 8;
                    case 8:
                        setRoleMeta(roleMeta);
                        dispatch({
                            role: roleInfo,
                            isAccount: roleMeta.channel === "account",
                        });
                        return [3 /*break*/, 10];
                    case 9:
                        err_1 = _b.sent();
                        (_a = onError === null || onError === void 0 ? void 0 : onError(err_1.message, err_1)) !== null && _a !== void 0 ? _a : console.error(err_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        return {
            displayName: sdkReady.SDK_TYPE === "HG"
                ? account.phone
                : account.displayName,
            onLogin: onLogin,
        };
    }, [
        disableAccount,
        fetchAccountRole,
        onNoRole,
        onSelectRole,
        account,
        sdkReady,
    ]);
    useEffect(function () {
        initial();
    }, []);
    return (_jsx(_Fragment, { children: render({
            currentAccount: currentAccount,
            channels: displayChannels,
        }) }));
};
